import type { BadgeProps } from '@wartek-id/badge'

import type { TObservationResultTypes } from 'types/kinerja-pelaksanaan'

export const OBSERVATION_RESULT_BADGE: Record<
  TObservationResultTypes,
  { text: string; variant: BadgeProps['variant'] }
> = {
  NOT_STARTED: {
    text: 'Belum Dilakukan',
    variant: 'critical',
  },

  START_NOT_EFFECTIVE: {
    text: 'Dilakukan Tapi Belum Efektif',
    variant: 'warning',
  },
  START_EFFECTIVE: {
    text: 'Dilakukan Dan Efektif',
    variant: 'success',
  },
}

export const OBSERVATION_RESULT_OPTIONS: Record<
  TObservationResultTypes,
  string
> = {
  NOT_STARTED: 'Belum Dilakukan',
  START_NOT_EFFECTIVE: 'Dilakukan Tapi Belum Efektif',
  START_EFFECTIVE: 'Dilakukan Dan Efektif',
}
